import React from 'react';

import { LabeledAvatar } from '@change/ds-core-ui/LabeledAvatar';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { RecentSigner } from '../../types';

export const RecentSignersFeedItem: React.FC<Props> = ({ item }) => {
	const { translate } = useI18n();

	// `displayNameAbbreviated` is formatted by user_service against the signer's own locale, so the client
	// needs to know nothing about how names are ordered or which locales abbreviate. It always has a value:
	// where nothing can be hidden the service returns the full display name, so there is no fallback here.
	const name = item.displayNameAbbreviated;

	return (
		<LabeledAvatar
			alt={name}
			name={name}
			metatext={translate('corgi.petition_gamma.petition_sign.recent_signers.signed', {
				createdAtRelativeLocalized: item.createdAtRelativeLocalized,
			})}
			size="x-small"
			src={item.photoUrl ?? undefined}
			container="inline"
		/>
	);
};

type Props = {
	item: RecentSigner;
};
